import StickyDownload from './StickyDownload'

export default StickyDownload
